import axios from "axios";
import {
  markNcrmNotificationItemsSeen,
  mergeNcrmNotificationItems,
  normalizeNcrmNotification,
} from "@/Utile/ncrmNotifications.mjs";

const NOTIFICATION_PAGE_SIZE = 50;

const normalizePage = (items) =>
  (Array.isArray(items) ? items : [])
    .map(normalizeNcrmNotification)
    .filter(Boolean);

export default {
  data() {
    return {
      items: [],
      loading: false,
      loadingMore: false,
      errorMessage: "",
      dismissingAll: false,
      dismissingIds: new Set(),
    };
  },
  methods: {
    async fetchNotificationPage() {
      const { data } = await axios.get("/ncrm/notifications", {
        params: { limit: NOTIFICATION_PAGE_SIZE },
      });
      return normalizePage(data?.items);
    },
    async deliverNotificationPage(pageItems) {
      const deliveredUnseenIds = pageItems
        .filter((item) => !item.seenAt)
        .map((item) => item.id);
      if (deliveredUnseenIds.length) {
        await this.markDeliveredSeen(deliveredUnseenIds);
      } else {
        await this.fetchSummary();
      }
    },
    async loadItems() {
      this.loading = true;
      this.errorMessage = "";
      try {
        const pageItems = await this.fetchNotificationPage();
        this.items = pageItems;
        await this.deliverNotificationPage(pageItems);
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.error || this.$t("ncrm.notifications.loadError");
      } finally {
        this.loading = false;
      }
    },
    async loadMoreUnseen() {
      if (this.loadingMore || this.unseenCount <= 0) return;
      this.loadingMore = true;
      this.errorMessage = "";
      try {
        const pageItems = await this.fetchNotificationPage();
        this.items = mergeNcrmNotificationItems(this.items, pageItems);
        await this.deliverNotificationPage(pageItems);
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.error || this.$t("ncrm.notifications.loadError");
      } finally {
        this.loadingMore = false;
      }
    },
    async markDeliveredSeen(notificationIds) {
      try {
        await axios.post("/ncrm/notifications/seen", {
          notificationIds,
          timezoneOffsetMinutes: new Date().getTimezoneOffset(),
        });
        this.items = markNcrmNotificationItemsSeen(this.items, notificationIds);
        await this.fetchSummary();
      } catch {
        await this.fetchSummary();
      }
    },
    async dismissOne(item) {
      if (!item?.id || this.dismissingIds.has(item.id)) return;
      this.dismissingIds = new Set([...this.dismissingIds, item.id]);
      try {
        await axios.delete(`/ncrm/notifications/${item.id}`);
        this.items = this.items.filter((entry) => entry.id !== item.id);
        await this.fetchSummary();
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.error || this.$t("ncrm.notifications.deleteError");
      } finally {
        const next = new Set(this.dismissingIds);
        next.delete(item.id);
        this.dismissingIds = next;
      }
    },
    async dismissAll() {
      if (this.dismissingAll) return;
      this.dismissingAll = true;
      this.errorMessage = "";
      try {
        await axios.delete("/ncrm/notifications");
        this.items = [];
        await this.fetchSummary();
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.error || this.$t("ncrm.notifications.deleteAllError");
      } finally {
        this.dismissingAll = false;
      }
    },
  },
};
